var _g, _path, _path2, _g2, _path3, _path4, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMyReferral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 46,
    viewBox: "0 0 39 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1640_38259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 43.9627C24.8805 44.1294 22.8661 43.7169 20.9022 43.1335C13.3788 40.9085 8.05054 36.3584 5.65347 28.7791C5.48946 28.2624 5.22872 28.0582 4.71146 28.0624C3.7274 28.0707 2.74334 28.0624 1.75928 28.0582C1.51117 28.0582 1.20838 28.1207 1.05698 27.8791C0.876152 27.5957 1.17053 27.4207 1.31772 27.2457C4.07645 23.954 6.84359 20.6748 9.59812 17.3789C10.0481 16.8414 10.3509 16.8955 10.784 17.4164C13.5175 20.6873 16.2721 23.9373 19.0182 27.1957C19.1738 27.3832 19.4639 27.5624 19.3504 27.8249C19.2158 28.1332 18.8584 28.0541 18.585 28.0582C17.601 28.0707 16.6169 28.0749 15.6328 28.0582C15.1324 28.0541 14.9137 28.1874 15.1366 28.7249C17.4538 34.3334 20.4606 39.4501 25.5702 43.0585C26.0286 43.3835 26.5248 43.6627 27 43.9627Z",
    fill: "url(#paint0_linear_1640_38259)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 36.4855H27.125C23.19 36.4855 20 39.7051 20 43.6767V44.8199C20 45.4717 20.5235 46 21.1692 46H37.8308C38.4765 46 39 45.4717 39 44.8199V43.6767C39 39.7051 35.81 36.4855 31.875 36.4855ZM29.5 35.3998C32.6189 35.3998 35.1474 32.8479 35.1474 29.6999C35.1474 26.5519 32.6189 24 29.5 24C26.381 24 23.8526 26.5519 23.8526 29.6999C23.8526 32.8479 26.381 35.3998 29.5 35.3998H29.5Z",
    fill: "url(#paint1_linear_1640_38259)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_38259",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 24,
    width: 19,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 36.4855H27.125C23.19 36.4855 20 39.7051 20 43.6767V44.8199C20 45.4717 20.5235 46 21.1692 46H37.8308C38.4765 46 39 45.4717 39 44.8199V43.6767C39 39.7051 35.81 36.4855 31.875 36.4855ZM29.5 35.3998C32.6189 35.3998 35.1474 32.8479 35.1474 29.6999C35.1474 26.5519 32.6189 24 29.5 24C26.381 24 23.8526 26.5519 23.8526 29.6999C23.8526 32.8479 26.381 35.3998 29.5 35.3998H29.5Z",
    fill: "url(#paint2_linear_1640_38259)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_38259)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.68,
    filter: "url(#filter1_f_1640_38259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 43.9627C24.8805 44.1294 22.8661 43.7169 20.9022 43.1335C13.3788 40.9085 8.05054 36.3584 5.65347 28.7791C5.48946 28.2624 5.22872 28.0582 4.71146 28.0624C3.7274 28.0707 2.74334 28.0624 1.75928 28.0582C1.51117 28.0582 1.20838 28.1207 1.05698 27.8791C0.876152 27.5957 1.17053 27.4207 1.31772 27.2457C4.07645 23.954 6.84359 20.6748 9.59812 17.3789C10.0481 16.8414 10.3509 16.8955 10.784 17.4164C13.5175 20.6873 16.2721 23.9373 19.0182 27.1957C19.1738 27.3832 19.4639 27.5624 19.3504 27.8249C19.2158 28.1332 18.8584 28.0541 18.585 28.0582C17.601 28.0707 16.6169 28.0749 15.6328 28.0582C15.1324 28.0541 14.9137 28.1874 15.1366 28.7249C17.4538 34.3334 20.4606 39.4501 25.5702 43.0585C26.0286 43.3835 26.5248 43.6627 27 43.9627Z",
    fill: "url(#paint3_linear_1640_38259)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 12.4855H13.125C9.19003 12.4855 6 15.7051 6 19.6767V20.8199C6 21.4717 6.52348 22 7.16923 22H23.8308C24.4765 22 25 21.4717 25 20.8199V19.6767C25 15.7051 21.81 12.4855 17.875 12.4855ZM15.5 11.3998C18.6189 11.3998 21.1474 8.84786 21.1474 5.6999C21.1474 2.55193 18.6189 0 15.5 0C12.381 0 9.85256 2.55193 9.85256 5.6999C9.85256 8.84786 12.381 11.3998 15.5 11.3998H15.5Z",
    fill: "url(#paint4_linear_1640_38259)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1640_38259",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 19,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 12.4855H13.125C9.19003 12.4855 6 15.7051 6 19.6767V20.8199C6 21.4717 6.52348 22 7.16923 22H23.8308C24.4765 22 25 21.4717 25 20.8199V19.6767C25 15.7051 21.81 12.4855 17.875 12.4855ZM15.5 11.3998C18.6189 11.3998 21.1474 8.84786 21.1474 5.6999C21.1474 2.55193 18.6189 0 15.5 0C12.381 0 9.85256 2.55193 9.85256 5.6999C9.85256 8.84786 12.381 11.3998 15.5 11.3998H15.5Z",
    fill: "url(#paint5_linear_1640_38259)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1640_38259)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.68,
    filter: "url(#filter2_f_1640_38259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 43.9627C24.8805 44.1294 22.8661 43.7169 20.9022 43.1335C13.3788 40.9085 8.05054 36.3584 5.65347 28.7791C5.48946 28.2624 5.22872 28.0582 4.71146 28.0624C3.7274 28.0707 2.74334 28.0624 1.75928 28.0582C1.51117 28.0582 1.20838 28.1207 1.05698 27.8791C0.876152 27.5957 1.17053 27.4207 1.31772 27.2457C4.07645 23.954 6.84359 20.6748 9.59812 17.3789C10.0481 16.8414 10.3509 16.8955 10.784 17.4164C13.5175 20.6873 16.2721 23.9373 19.0182 27.1957C19.1738 27.3832 19.4639 27.5624 19.3504 27.8249C19.2158 28.1332 18.8584 28.0541 18.585 28.0582C17.601 28.0707 16.6169 28.0749 15.6328 28.0582C15.1324 28.0541 14.9137 28.1874 15.1366 28.7249C17.4538 34.3334 20.4606 39.4501 25.5702 43.0585C26.0286 43.3835 26.5248 43.6627 27 43.9627Z",
    fill: "url(#paint6_linear_1640_38259)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1640_38259",
    x: 0,
    y: 15,
    width: 30,
    height: 31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.980392 0 0 0 0 0.85898 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1640_38259"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1640_38259",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1640_38259",
    x: 0,
    y: 16,
    width: 28,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1640_38259"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1640_38259",
    x: 0,
    y: 16,
    width: 28,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1640_38259"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_38259",
    x1: 20.4983,
    y1: 43.4609,
    x2: 9.35015,
    y2: 20.1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51FFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CF5C2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1640_38259",
    x1: 20,
    y1: 35,
    x2: 39,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1FFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1640_38259",
    x1: 20,
    y1: 35,
    x2: 39,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1640_38259",
    x1: 20.4983,
    y1: 43.4609,
    x2: 9.35015,
    y2: 20.1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51FFCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CF5D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1640_38259",
    x1: 6,
    y1: 11,
    x2: 25,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1FFE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3FFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1640_38259",
    x1: 6,
    y1: 11,
    x2: 25,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1640_38259",
    x1: 20.4983,
    y1: 43.4609,
    x2: 9.35015,
    y2: 20.1011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51FFAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CF5CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMyReferral);
export default __webpack_public_path__ + "static/media/menu-my-referral.323b2b54819cf895d398955c67656aab.svg";
export { ForwardRef as ReactComponent };